/**
 * @fileoverview gRPC-Web generated client stub for mycargo.projects.erp.api.v1.services
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v3.20.3
// source: projects/erp/service/api/v1/services/documents.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_field_mask_pb = require('google-protobuf/google/protobuf/field_mask_pb.js')

var projects_erp_service_api_v1_model_document_pb = require('./document_pb.js')
const proto = {};
proto.mycargo = {};
proto.mycargo.projects = {};
proto.mycargo.projects.erp = {};
proto.mycargo.projects.erp.api = {};
proto.mycargo.projects.erp.api.v1 = {};
proto.mycargo.projects.erp.api.v1.services = require('./documents_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.mycargo.projects.erp.api.v1.services.DocumentsClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.mycargo.projects.erp.api.v1.services.DocumentsPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mycargo.projects.erp.api.v1.services.ListDocumentsRequest,
 *   !proto.mycargo.projects.erp.api.v1.services.ListDocumentsResponse>}
 */
const methodDescriptor_Documents_ListDocuments = new grpc.web.MethodDescriptor(
  '/mycargo.projects.erp.api.v1.services.Documents/ListDocuments',
  grpc.web.MethodType.UNARY,
  proto.mycargo.projects.erp.api.v1.services.ListDocumentsRequest,
  proto.mycargo.projects.erp.api.v1.services.ListDocumentsResponse,
  /**
   * @param {!proto.mycargo.projects.erp.api.v1.services.ListDocumentsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.mycargo.projects.erp.api.v1.services.ListDocumentsResponse.deserializeBinary
);


/**
 * @param {!proto.mycargo.projects.erp.api.v1.services.ListDocumentsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mycargo.projects.erp.api.v1.services.ListDocumentsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mycargo.projects.erp.api.v1.services.ListDocumentsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mycargo.projects.erp.api.v1.services.DocumentsClient.prototype.listDocuments =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mycargo.projects.erp.api.v1.services.Documents/ListDocuments',
      request,
      metadata || {},
      methodDescriptor_Documents_ListDocuments,
      callback);
};


/**
 * @param {!proto.mycargo.projects.erp.api.v1.services.ListDocumentsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mycargo.projects.erp.api.v1.services.ListDocumentsResponse>}
 *     Promise that resolves to the response
 */
proto.mycargo.projects.erp.api.v1.services.DocumentsPromiseClient.prototype.listDocuments =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mycargo.projects.erp.api.v1.services.Documents/ListDocuments',
      request,
      metadata || {},
      methodDescriptor_Documents_ListDocuments);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mycargo.projects.erp.api.v1.services.GetDocumentRequest,
 *   !proto.mycargo.projects.erp.api.v1.model.Document>}
 */
const methodDescriptor_Documents_GetDocument = new grpc.web.MethodDescriptor(
  '/mycargo.projects.erp.api.v1.services.Documents/GetDocument',
  grpc.web.MethodType.UNARY,
  proto.mycargo.projects.erp.api.v1.services.GetDocumentRequest,
  projects_erp_service_api_v1_model_document_pb.Document,
  /**
   * @param {!proto.mycargo.projects.erp.api.v1.services.GetDocumentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  projects_erp_service_api_v1_model_document_pb.Document.deserializeBinary
);


/**
 * @param {!proto.mycargo.projects.erp.api.v1.services.GetDocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mycargo.projects.erp.api.v1.model.Document)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mycargo.projects.erp.api.v1.model.Document>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mycargo.projects.erp.api.v1.services.DocumentsClient.prototype.getDocument =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mycargo.projects.erp.api.v1.services.Documents/GetDocument',
      request,
      metadata || {},
      methodDescriptor_Documents_GetDocument,
      callback);
};


/**
 * @param {!proto.mycargo.projects.erp.api.v1.services.GetDocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mycargo.projects.erp.api.v1.model.Document>}
 *     Promise that resolves to the response
 */
proto.mycargo.projects.erp.api.v1.services.DocumentsPromiseClient.prototype.getDocument =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mycargo.projects.erp.api.v1.services.Documents/GetDocument',
      request,
      metadata || {},
      methodDescriptor_Documents_GetDocument);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mycargo.projects.erp.api.v1.services.CreateDocumentRequest,
 *   !proto.mycargo.projects.erp.api.v1.model.Document>}
 */
const methodDescriptor_Documents_CreateDocument = new grpc.web.MethodDescriptor(
  '/mycargo.projects.erp.api.v1.services.Documents/CreateDocument',
  grpc.web.MethodType.UNARY,
  proto.mycargo.projects.erp.api.v1.services.CreateDocumentRequest,
  projects_erp_service_api_v1_model_document_pb.Document,
  /**
   * @param {!proto.mycargo.projects.erp.api.v1.services.CreateDocumentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  projects_erp_service_api_v1_model_document_pb.Document.deserializeBinary
);


/**
 * @param {!proto.mycargo.projects.erp.api.v1.services.CreateDocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mycargo.projects.erp.api.v1.model.Document)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mycargo.projects.erp.api.v1.model.Document>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mycargo.projects.erp.api.v1.services.DocumentsClient.prototype.createDocument =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mycargo.projects.erp.api.v1.services.Documents/CreateDocument',
      request,
      metadata || {},
      methodDescriptor_Documents_CreateDocument,
      callback);
};


/**
 * @param {!proto.mycargo.projects.erp.api.v1.services.CreateDocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mycargo.projects.erp.api.v1.model.Document>}
 *     Promise that resolves to the response
 */
proto.mycargo.projects.erp.api.v1.services.DocumentsPromiseClient.prototype.createDocument =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mycargo.projects.erp.api.v1.services.Documents/CreateDocument',
      request,
      metadata || {},
      methodDescriptor_Documents_CreateDocument);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mycargo.projects.erp.api.v1.services.DeleteDocumentRequest,
 *   !proto.mycargo.projects.erp.api.v1.services.DeleteDocumentResponse>}
 */
const methodDescriptor_Documents_DeleteDocument = new grpc.web.MethodDescriptor(
  '/mycargo.projects.erp.api.v1.services.Documents/DeleteDocument',
  grpc.web.MethodType.UNARY,
  proto.mycargo.projects.erp.api.v1.services.DeleteDocumentRequest,
  proto.mycargo.projects.erp.api.v1.services.DeleteDocumentResponse,
  /**
   * @param {!proto.mycargo.projects.erp.api.v1.services.DeleteDocumentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.mycargo.projects.erp.api.v1.services.DeleteDocumentResponse.deserializeBinary
);


/**
 * @param {!proto.mycargo.projects.erp.api.v1.services.DeleteDocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mycargo.projects.erp.api.v1.services.DeleteDocumentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mycargo.projects.erp.api.v1.services.DeleteDocumentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mycargo.projects.erp.api.v1.services.DocumentsClient.prototype.deleteDocument =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mycargo.projects.erp.api.v1.services.Documents/DeleteDocument',
      request,
      metadata || {},
      methodDescriptor_Documents_DeleteDocument,
      callback);
};


/**
 * @param {!proto.mycargo.projects.erp.api.v1.services.DeleteDocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mycargo.projects.erp.api.v1.services.DeleteDocumentResponse>}
 *     Promise that resolves to the response
 */
proto.mycargo.projects.erp.api.v1.services.DocumentsPromiseClient.prototype.deleteDocument =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mycargo.projects.erp.api.v1.services.Documents/DeleteDocument',
      request,
      metadata || {},
      methodDescriptor_Documents_DeleteDocument);
};


module.exports = proto.mycargo.projects.erp.api.v1.services;

